module.exports = __webpack_public_path__ + "img/10C.bd17caf6.svg";